"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    types: {
        ETHBlock: {
            inner: 'Block'
        },
        ETHReceipts: {
            inner: 'Vec<EthReceipt>'
        },
        ETHTxStatuses: {
            inner: 'Vec<EthTransactionStatus>'
        }
    }
};
